import posthog from 'posthog-js';
import {
  EVENTS,
  buildPaymentEventProperties,
  type PaymentEventProperties,
} from '@attik/posthog';
import { withTraceContext, type ObservabilityContext } from './observability';

function paymentProps(
  context?: ObservabilityContext
): Record<string, unknown> {
  return buildPaymentEventProperties({
    payment_flow: 'portal',
    ...(withTraceContext(context) as PaymentEventProperties),
  });
}

export function capturePaymentSubmitted(context?: ObservabilityContext): void {
  posthog.capture(EVENTS.paymentSubmitted, paymentProps(context));
}

export function capturePaymentCompleted(context?: ObservabilityContext): void {
  posthog.capture(EVENTS.paymentCompleted, paymentProps(context));
}

export function capturePaymentFailed(
  error: Error | string,
  context?: ObservabilityContext
): void {
  const ctx = withTraceContext(context);
  const failureMessage = error instanceof Error ? error.message : error;
  posthog.capture(
    EVENTS.paymentFailed,
    buildPaymentEventProperties({
      payment_flow: 'portal',
      ...(ctx as PaymentEventProperties),
      failure_message:
        (typeof ctx.failure_message === 'string' && ctx.failure_message) ||
        failureMessage,
      failure_code:
        typeof ctx.failure_code === 'string'
          ? ctx.failure_code
          : typeof ctx.code === 'string'
            ? ctx.code
            : undefined,
    })
  );
}
